var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _PatientEnrolledJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import { service } from "@ember/service";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import RSVP from "rsvp";

//---- Automatically generated, don't update this part ----
/**
 * Created when a patient is enrolled.
 */
let PatientEnrolledJournalEvent = (_dec = attr("string"), _dec2 = belongsTo("patient", {
  async: false,
  inverse: "patientEnrolledJournalEvent"
}), _class = (_PatientEnrolledJournalEvent = class PatientEnrolledJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "followUpReason", _descriptor, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "patient", _descriptor3, this);
  }
  static validations(intl) {
    return {
      followUpReason: [validatePresence({
        presence: true,
        description: intl.t("validations.patient-enrolled-journal-event.follow-up-reason")
      }), validateInclusion({
        list: ["generic-general", "cardio-heart-failure", "cardio-transplant", "nephro-transplant", "nephro-mrc", "nephro-donor", "nephro-generic", "hepato-transplant", "pneumo-transplant", "mental-bipolar", "mental-depression", "onco-breast-cancer", "onco-breast-cancer-tnm0", "onco-lymphoma-cancer", "onco-myeloma-cancer", "onco-colon-cancer", "onco-lung-cancer", "onco-prostate-cancer", "onco-ovarian-cancer", "onco-testicular-cancer", "onco-brain-cancer", "onco-pancreatic-cancer", "onco-liver-cancer", "onco-kidney-cancer", "onco-stomach-cancer", "onco-hemato-cancer", "onco-cervix-cancer", "onco-skin-cancer", "rhumato-pr", "diabeto-dt2", "digest-crohn", "digest-rch"],
        description: intl.t("validations.patient-enrolled-journal-event.follow-up-reason")
      })],
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.patient-enrolled-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })]
    };
  }
  save(options) {
    if (!this.followUpReason?.startsWith("mental") || !this.isNew) return super.save(options);
    return RSVP.Promise.all([super.save(options), this._createAssociatedJEs()]).then(() => this);
  }
  _createAssociatedJEs() {
    const protocolAssessmentVisitTask = this.store.createRecord("task-planned-journal-event", {
      occurredAt: dayjs().add(3, "M").toDate(),
      patient: this.patient,
      taskType: "protocol-assessment-visit",
      responsibleId: this.session.medic.id,
      responsibleType: "medic",
      comment: `Première visite d'évaluation du protocole prévue automatiquement trois mois après l'inclusion du patient`
    });
    const protocolAssessmentVisitRdvTask = this.store.createRecord("task-planned-journal-event", {
      occurredAt: dayjs(protocolAssessmentVisitTask.occurredAt).subtract(10, "d").toDate(),
      patient: this.patient,
      taskType: "protocol-assessment-visit-rdv",
      responsibleId: this.session.medic.id,
      responsibleType: "medic"
    });
    return Promise.all([protocolAssessmentVisitTask.save(), protocolAssessmentVisitRdvTask.save()]).then(() => this);
  }
}, _defineProperty(_PatientEnrolledJournalEvent, "type", "patient-enrolled-journal-event"), _PatientEnrolledJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "followUpReason", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PatientEnrolledJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.